import request from "@/utils/request";

export function palmStatusGetAllForDropdown(params) {
    return request({
        url: "/api/services/app/PalmStatus/GetAllForDropdown",
        method: "GET",
        params
    });
}

export function palmStatusGet(params) {
    return request({
        url: "/api/services/app/PalmStatus/Get",
        method: "GET",
        params
    });
}

export function palmStatusCreate(data) {
    return request({
        url: "/api/services/app/PalmStatus/Create",
        method: "POST",
        data
    });
}

export function palmStatusUpdate(data) {
    return request({
        url: "/api/services/app/PalmStatus/Update",
        method: "PUT",
        data
    });
}

export function palmStatusDelete(params) {
    return request({
        url: "/api/services/app/PalmStatus/Delete",
        method: "DELETE",
        params
    });
}



// WEBPACK FOOTER //
// ./src/api/palm_status.js